import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import snap_svg from '../../../assets/img/SVG_icons/Top/reference_operation/snap_to_object.svg';
import { img } from '@phi/components';
import { abort_snap_to_object, start_snap_to_object } from '@frontend/ui_display';
import SnapToObjectTooltip from './SnapToObjectTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const SnapIcon = snap_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Snap to Object';
        },

        disabled() {
            return !this.state.loaded
                || this.state.is_demo
                || this.state.editing_reference_sketches
                || this.total_selected_elements !== 1;
        },

        total_selected_elements() {
            return this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.snapping_to_object)
                abort_snap_to_object();
            else
                start_snap_to_object();
        },
    },

    render() {
        return h(BarButton, {
            id: 'snap-to-object-button',
            tippy: 'left',
            active: this.state.snapping_to_object,
            disabled: this.disabled,
            selected: this.state.tut_stage === 5,
            onClick: this.onClick,
            help: 'snap_to_object',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(snap_svg, this.alt),
            tooltip: SnapToObjectTooltip,
        });
    },
});
